import base from "./base"
export default {
  ...base,
  name: {
    type: ['undefined', 'string']
  },
  title: {
    type: ['undefined', 'string']
  },
  description: {
    type: ['undefined', 'string']
  },
  is_special: {
    type: ['boolean'],
    default: false
  },
  banner: {
    type: ['object'],
    default: () => {}
  },
  background_color: {
    type: ['undefined', 'string']
  },
}
